export default "__VITE_ASSET__6oj6s596__"